<template>
  <div class="edit-service-area-page">
    <div class="head-wrap flex-rowl">
      <div class="icon">
        <img src="../../../assets/images/business-title-icon.png" alt="" />
      </div>
      <div class="head-content">
        <h1>新增服务责任片区</h1>
        <p>业务区域管理</p>
      </div>
    </div>

    <!-- 表单 -->
    <div class="from-wrap">
      <div class="from-item mb_85">
        <div class="label"><span class="requird"></span>片区名称：</div>
        <div class="input-box">
          <input
            type="text"
            placeholder="请输入片区名称，30个字符内"
            maxlength="30"
            v-model="params.raname"
          />
        </div>
      </div>

      <div class="from-item mb_100">
        <div class="label"><span class="requird"></span>关联街道（多选）</div>

        <div class="label_wrap" v-if="selectstreetList.length > 0">
          <div
            class="spe_info_item label_item flex-rowl"
            v-for="(item, index) in selectstreetList"
            :key="index"
          >
            <div class="txt">[ 已选街道名称 ]：</div>
            <div class="box flex-rowl">{{ item.streetname }}</div>
            <div class="operation_wrap flex-rowc">
              <div
                class="cancel_box flex-rowc"
                @click="handleDelSelectLabel(item, 'streetList')"
              >
                <van-icon name="delete-o" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="add_btn flex-rowc"
          @click="handleShowRadio('streetList', 'isShowStreet')"
        >
          <van-icon name="plus" /> 关联合作服务机构（多选）
        </div>
      </div>

      <div class="from-item mb_100">
        <div class="label"><span class="requird"></span>关联合作服务机构：</div>

        <div class="label_wrap" v-if="selectserviceList.length > 0">
          <div
            class="spe_info_item label_item flex-rowl"
            v-for="(item, index) in selectserviceList"
            :key="index"
          >
            <div class="txt">[ 已选机构名称 ]：</div>
            <div class="box flex-rowl">{{ item.svname }}</div>
            <div class="operation_wrap flex-rowc">
              <div
                class="cancel_box flex-rowc"
                @click="handleDelSelectLabel(item, 'serviceList')"
              >
                <van-icon name="delete-o" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="add_btn flex-rowc"
          @click="handleShowRadio('serviceList', 'isShowNb')"
        >
          <van-icon name="plus" /> 设置关联合作服务机构
        </div>
      </div>

      <div class="from-item form-item-radio">
        <div class="label"><span class="requird"></span> 服务片区状态？</div>
        <div class="radio-box flex-rowc">
          <div
            class="radio-item flex-rowl"
            :class="{ active: params.rastate === '1' }"
            @click="handleRadio('rastate', '1')"
          >
            启用
          </div>
          <div
            class="radio-item flex-rowl"
            :class="{ active: params.rastate === '0' }"
            @click="handleRadio('rastate', '0')"
          >
            停用
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="fixed-btm flex-rowc">
      <div class="return flex-rowc" @click="handleBack">返回</div>
      <div
        class="add-btn flex-rowc"
        :class="{ disanled: isSubmitting }"
        @click="handleSubmit"
      >
        确认·保存
      </div>
    </div>

    <!-- 关联所属街道 -->
    <van-overlay :show="isShowStreet" z-index="10001" :lock-scroll="false">
      <div class="custom_popup">
        <div class="custom_popup_head flex-between">
          <div class="tit flex-rowl">
            请选择关联街道 <span>（多选）</span>
          </div>
          <span class="close" @click="handleCloseRadio('isShowStreet')"
            ><van-icon name="cross"
          /></span>
        </div>
        <div
          class="custom_popup_body"
          ref="customPopupBody"
          @scroll="handleScroll"
        >
          <div
            class="custom_popup_body_list flex-rowl"
            v-if="streetList.length > 0 && !isLoading"
          >
            <div
              class="custom_popup_body_item flex-rowl"
              v-for="(item, index) in streetList"
              :key="index"
              @click="handleItem(item, 'streetList', 'multiple')"
            >
              {{ item.streetname }}
              <span class="active" v-if="item.active"></span>
            </div>
          </div>
          <div class="hasMore flex-rowc" v-if="hasMore && streetList.length == totalPage">暂无更多数据...</div>
          <!-- 无数据 -->
          <div
            class="custom_date flex-colc"
            v-if="streetList.length == 0 && !isLoading"
          >
            <div class="custom_date_img">
              <img
                src="../../../assets/images/no-date.png"
                alt=""
                class="custom_date_img"
              />
            </div>
            <div
              class="custom_date_btn flex-rowc"
              @click="handleGo('EditStreetManagement')"
            >
              添加关联所属街道
            </div>
          </div>
        </div>
        <div class="custom_popup_footer flex-between">
          <div
            class="return flex-rowc"
            @click="handleCloseRadio('isShowStreet')"
          >
            <van-icon name="arrow-left" />返回
          </div>
          <div
            class="btn flex-rowc"
            @click="handleSubmitLabel('streetList', 'isShowStreet', 'multiple')"
          >
            确认
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 关联服务机构 -->
    <van-overlay :show="isShowNb" z-index="10001" :lock-scroll="false">
      <div class="custom_popup">
        <div class="custom_popup_head flex-between">
          <div class="tit flex-rowl">
            关联合作服务机构 <span>（多选）</span>
          </div>
          <span class="close" @click="handleCloseRadio('isShowNb')"
            ><van-icon name="cross"
          /></span>
        </div>
        <div
          class="custom_popup_body"
          ref="customPopupBody1"
          @scroll="handleScroll1"
        >
          <div
            class="custom_popup_body_list flex-rowl"
            v-if="serviceList.length > 0 && !isLoading1"
          >
            <div
              class="custom_popup_body_item flex-rowl"
              v-for="(item, index) in serviceList"
              :key="index"
              @click="handleItem(item, 'serviceList', 'multiple')"
            >
              {{ item.svname }}
              <span class="active" v-if="item.active"></span>
            </div>
          </div>
          <div class="hasMore flex-rowc" v-if="hasMore1 && serviceList.length == totalPage1">暂无更多数据...</div>
          <!-- 无数据 -->
          <div
            class="custom_date flex-colc"
            v-if="serviceList.length == 0 && !isLoading1"
          >
            <div class="custom_date_img">
              <img
                src="../../../assets/images/no-date.png"
                alt=""
                class="custom_date_img"
              />
            </div>
            <div
              class="custom_date_btn flex-rowc"
              @click="handleGo('EditCommunityManagement')"
            >
              添加关联合作服务机构
            </div>
          </div>
        </div>
        <div class="custom_popup_footer flex-between">
          <div class="return flex-rowc" @click="handleCloseRadio('isShowNb')">
            <van-icon name="arrow-left" />返回
          </div>
          <div
            class="btn flex-rowc"
            @click="handleSubmitLabel('serviceList', 'isShowNb', 'multiple')"
          >
            确认
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  getStreetList,
  getServiceList,
  addServiceArea,
  editServiceArea,
  getServiceAreaDetail,
} from "../../../api/api";
export default {
  name: "EditServiceAreaManagement",
  data() {
    return {
      // 参数
      params: {
        id: "",
        raname: "",
        streetid: "", // 片区关联街道id
        serviceid: "", // 服务机构id
        rastate: "", // 服务机构状态 =1=启用|0=停用|
      },

      // 街道start
      streetList: [], // 街道列表
      streetParams: {
        pageindex: 1,
        pagesize: 35,
        keyword: "",
        streetstate: 1, // 街道状态 =1=启用|0=停用|
      },
      totalPage: 1, // 总页数
      isLoading: true, // 是否正在加载
      hasMore: false, // 是否还有更多数据
      isShowStreet: false, // 显示街道列表
      // 选中的街道
      selectstreetList: [],
      // 街道end

      // 服务机构 start
      serviceList: [], // 服务机构列表
      serviceParams: {
        pageindex: 1,
        pagesize: 35,
        keyword: "",
        svstate: 1, // 1=启用|0=停用|
      },
      totalPage1: 1, // 总页数
      isLoading1: true, // 是否正在加载
      hasMore1: false, // 是否还有更多数据
      isShowNb: false, // 显示居委列表
      // 选中的服务机构
      selectserviceList: [],
      // 居委 end

      isLoadingMore: false, // 新增加载状态锁

      isSubmitting: false, // 提交中标记
    };
  },
  created() {
    this.getStreetList();
    this.getServiceList()

    if (this.$route.query.id) {
      this.params.id = this.$route.query.id;
      this.getServiceAreaDetail();
    }
  },
  methods: {
    // 获取街道列表
    async getStreetList() {
      try {
        const res = await getStreetList(this.streetParams);
        if (res.list) {
          this.streetList = this.streetList.concat(res.list);
          this.totalPage = res.total;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading1 = false;
      }
    },

    // 服务机构管理
    async getServiceList() {
      try {
        const res = await getServiceList(this.serviceParams);
        if (res.list) {
          this.serviceList = this.serviceList.concat(res.list);
          this.totalPage1 = res.total;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    // 获取服务机构详情
    async getServiceAreaDetail() {
      const res = await getServiceAreaDetail(this.params.id);
      try {
        this.params.raname = res.raname;
        this.params.streetid = res.streetid;
        this.params.serviceid = res.serviceid;
        this.params.rastate = res.rastate;
        this.selectstreetList = res.streetidlist;
        this.selectserviceList = res.serviceidlist;
      } catch (error) {
        console.error("获取街道详情失败:", error);
        this.$toast.fail("获取街道详情失败，请稍后重试");
      }
    },

    /**
     * 单选操作start
     */
    // 1、显示弹窗
    handleShowRadio(list, name) {
      const targetList = this[list];
      const selectList = this[`select${list}`];
      // 调用新方法设置 active 状态
      this.setActiveStatus(targetList, selectList);
      this[name] = true;
    },
    // 2、关闭弹窗
    handleCloseRadio(name) {
      this[name] = false;
    },
    // 3、选中标签
    handleItem(item, list, type) {
      const targetList = this[list];
      if (!Array.isArray(targetList)) {
        console.error("传入的 list 不是有效的数组");
        return;
      }
      if (type === "single") {
        targetList.forEach((listItem) => {
          this.$set(listItem, "active", listItem.id === item.id);
        });
      } else if (type === "multiple") {
        const targetIndex = targetList.findIndex(
          (listItem) => listItem.id === item.id
        );
        if (targetIndex !== -1) {
          const targetItem = targetList[targetIndex];
          this.$set(targetItem, "active", !targetItem.active);
        }
      }
    },
    // 4、确认选中的标签
    handleSubmitLabel(list, name, type) {
      const targetList = this[list];
      const selectList = this[`select${list}`];
      // 过滤出 targetList 中 active 为 true 的元素
      const selectedItems = targetList.filter((item) => item.active);
      if (type === "single") {
        // 清空原列表，添加单个选中项
        selectList.splice(0, selectList.length, ...selectedItems);
      } else if (type === "multiple") {
        // 避免添加重复项
        const newItems = selectedItems.filter(
          (item) =>
            !selectList.some((existingItem) => existingItem.id === item.id)
        );
        selectList.push(...newItems);
      }
      // 确保 Vue 能检测到 selectList 的变化
      this.$set(this, `select${list}`, selectList);
      this[name] = false;
    },
    // 5、删除选中的标签
    handleDelSelectLabel(item, list) {
      const selectList = this[`select${list}`];
      console.log(selectList, "====");

      const index = selectList.findIndex((listItem) => listItem.id === item.id);
      if (index !== -1) {
        selectList.splice(index, 1);
        this.$set(this, `select${list}`, selectList);
      }
    },
    // 抽离出来的设置 active 状态的方法
    setActiveStatus(targetList, selectList) {
      if (selectList.length > 0) {
        const selectedIds = selectList.map((item) => item.id);
        targetList.forEach((item) => {
          // 使用 this.$set 确保 active 属性具有响应式
          this.$set(item, "active", selectedIds.includes(item.id));
        });
      } else {
        // 如果没有选中的街道，将所有项的 active 设为 false
        targetList.forEach((item) => {
          this.$set(item, "active", false);
        });
      }
    },
    // 处理滚动事件-街道
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } =
        this.$refs.customPopupBody;
      let { streetList, totalPage, isLoadingMore } = this;
      if (isLoadingMore || streetList.length >= totalPage) return;
      // 当滚动到底部 20px 范围内时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.hasMore = true;
        this.streetParams.pageindex++;
        this.isLoadingMore = true; // 开始加载，设置锁
        this.getStreetList().finally(() => {
          // 调用新方法设置 active 状态
          this.setActiveStatus(this.streetList, this.selectstreetList);
          this.isLoadingMore = false; // 加载完成，释放锁
        });
      }
    },
    // 处理滚动事件-服务机构
    handleScroll1() {
      const { scrollTop, scrollHeight, clientHeight } =
        this.$refs.customPopupBody1;
      let { serviceList, totalPage1, isLoadingMore } = this;
      if (isLoadingMore || serviceList.length >= totalPage1) return;
      // 当滚动到底部 20px 范围内时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.hasMore1 = true;
        this.serviceParams.pageindex++;
        this.isLoadingMore = true; // 开始加载，设置锁
        this.getCommunityList().finally(() => {
          // 调用新方法设置 active 状态
          this.setActiveStatus(this.serviceList, this.selectserviceList);
          this.isLoadingMore = false; // 加载完成，释放锁
        });
      }
    },
    /**
     * 单选操作end
     */

     // 触发单选框
    handleRadio(name, item) {
      this.params[name] = item;
    },

    handleGo(name) {
      this.$router.push({ name });
    },

    // 返回上一页
    handleBack() {
      this.$router.back();
    },

    // 提交
    async handleSubmit() {
      let { raname, rastate } = this.params;
      let { selectstreetList, selectserviceList } = this;
      if (!raname) {
        this.$toast("请输入片区名称");
        return;
      }
      if (selectstreetList.length == 0) {
        this.$toast("请选择街道");
        return;
      }
      if (selectserviceList.length == 0) {
        this.$toast("请选择服务机构");
        return;
      }
      if (!rastate) {
        this.$toast("请选择服务片区状态");
        return;
      }

      // 处理街道id
      if (selectstreetList.length > 0) {
        this.params.streetid = selectstreetList
          .map((item) => item.id)
          .join(",");
      }

      // 处理服务机构id
      if (selectserviceList.length > 0) {
        this.params.serviceid = selectserviceList.map((item) => item.id).join(",");
      }

      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      // 设置提交中标记
      this.isSubmitting = true;
      // 显示加载中提示
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let res;
        if (this.params.id) {
          // params.id 存在，调用 editServiceArea 接口
          res = await editServiceArea(this.params);
        } else {
          // params.id 不存在，调用 addServiceArea 接口
          res = await addServiceArea(this.params);
        }

        if (res.result == "true") {
          await new Promise((resolve) => setTimeout(resolve, 400));
          this.$toast.success("提交成功");

          await new Promise((resolve) => setTimeout(resolve, 800));
          // 提交成功后返回上一页
          this.$toast.clear();
          this.$router.back();
          this.isSubmitting = false;
        } else {
          this.$toast.fail(res.message || "提交失败，请稍后重试");
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$toast.fail("提交出错，请稍后重试");
        this.isSubmitting = false;
      } finally {
        // 无论成功或失败，都关闭加载提示并重置提交状态
        // this.$toast.clear();
        // this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.edit-service-area-page {
  padding-bottom: 380px;
  box-sizing: border-box;
  .head-wrap {
    width: 700px;
    margin: auto;
    padding: 70px 0 98px 58px;
    box-sizing: border-box;
    font-size: 20px;
    color: #333333;
    .icon {
      width: 33px;
      height: 40px;
      margin-right: 24px;
    }
    h1 {
      font-size: 30px;
      margin-bottom: 7px;
    }
  }
  .from-wrap {
    width: 600px;
    margin: auto;
    .from-item {
      .label {
        position: relative;
        font-size: 26px;
        color: #333333;
        padding-left: 12px;
        box-sizing: border-box;
        margin-bottom: 23px;
        .requird {
          width: 15px;
          height: 15px;
          background: url("../../../assets/images/required-icon.png") no-repeat
            center;
          background-size: cover;
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -12px;
        }
      }
      &.form-item-radio {
        .label {
          margin-bottom: 60px;
        }
      }
      .input-box,
      .select-box {
        border-bottom: 1px solid #c3c3c3;
        font-size: 24px;
        height: 52px;
        padding: 0 13px;
        box-sizing: border-box;
        input {
          height: 100%;
          width: 100%;
          background: none;
        }
      }
      .select-box {
        position: relative;
        border-bottom: 1px dashed #c3c3c3;
        padding-right: 20px;
        color: #aaaaaa;
        line-height: 52px;
        &.has-value {
          color: #333333;
        }
        input {
          text-align: center;
        }
        &::after {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/select-icon.png") no-repeat
            center;
          background-size: cover;
          width: 26px;
          height: 30px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
        }
      }
      .textarea-box {
        font-size: 24px;
        width: 100%;
        height: 190px;
        padding: 17px 22px;
        box-sizing: border-box;
        background: #fff;
        textarea {
          width: 100%;
          height: 100%;
        }
      }
      .radio-box {
        font-size: 24px;
        color: #464646;
        flex-wrap: wrap;
        .radio-item {
          position: relative;
          margin-right: 40px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &::before {
            display: inline-block;
            content: "";
            display: inline-block;
            width: 30px;
            height: 30px;
            background: url("../../../assets/images/radio-icon.png") no-repeat
              center;
            background-size: cover;
            margin-right: 15px;
            opacity: 0.4;
          }
          &.active {
            &::before {
              opacity: 1;
            }
          }
        }
      }
      .label_wrap {
        margin-top: 20px;
        font-size: 24px;
        color: #333333;
        .box {
          flex: 1;
          height: 60px;
          border-bottom: 1px solid #c3c3c3;
          padding: 0 10px;
          box-sizing: border-box;
          // 单行文本隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .operation_wrap {
          font-size: 30px;
        }
      }
      .add_btn {
        width: 100%;
        height: 60px;
        background: #ffffff;
        border-radius: 10px;
        border: 2px dashed #666666;
        margin: auto;
        font-size: 26px;
        color: #666666;
        margin-top: 60px;
        cursor: pointer;
      }
    }
    .from-item-address {
      color: #333333;
      .tit {
        font-size: 26px;

        font-weight: bold;
        margin-bottom: 59px;
        padding-left: 19px;
        box-sizing: border-box;
        position: relative;
        &::before {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/address-form-icon.png")
            no-repeat center;
          background-size: cover;
          width: 28px;
          height: 35px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -20px;
        }
      }
      .txt {
        font-size: 26px;
        padding-left: 13px;
        box-sizing: border-box;
        p {
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
    .mb_85 {
      margin-bottom: 85px;
    }
    .mb_75 {
      margin-bottom: 75px;
    }
    .mb_100 {
      margin-bottom: 100px;
    }
    .mb_60 {
      margin-bottom: 60px;
    }
    .mb_110 {
      margin-bottom: 110px;
    }
    .mb_30 {
      margin-bottom: 30px;
    }
  }
  .fixed-btm {
    position: fixed;
    bottom: 0;
    height: 150px;
    background: #fff;
    z-index: 10;
    align-items: flex-start;
    width: 100%;
    max-width: 750px;
    margin: auto;
    cursor: pointer;
    .return {
      font-size: 24px;
      color: #000000;
      height: 100%;
      width: 150px;
      align-items: flex-start;
      padding-top: 50px;
      box-sizing: border-box;
      margin-right: 30px;
      &::before {
        display: inline-block;
        content: "";
        background: url("../../../assets/images/return-icon.png") no-repeat
          center;
        background-size: cover;
        width: 15px;
        height: 25px;
        margin-right: 8px;
      }
    }
    .add-btn {
      width: 210px;
      height: 50px;
      background: #0031c9;
      border-radius: 25px;
      font-size: 24px;
      color: #fff;
      margin-top: 38px;
      &.disanled {
        background: #d9d9d9;
      }
    }
  }
  .custom_popup {
    height: 70vh;
    width: 100%;
    border-radius: 30px 30px 0 0;
    position: fixed;
    bottom: 0;
    z-index: 999;
    background: #fff;
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
    .icon-jujueweituo {
      position: absolute;
      display: inline-block;
      font-size: 56px;
      left: 50%;
      transform: translateX(-50%);
      top: -80px;
      color: #fff;
    }
    .custom_popup_head {
      height: 110px;
      padding: 0 30px;
      box-sizing: border-box;
      .tit {
        font-size: 24px;
        color: #3c3c3c;
        position: relative;
        &::before {
          width: 5px;
          height: 28px;
          background: #ff0042;
          margin-right: 12px;
          display: inline-block;
          content: "";
        }
        span {
          font-size: 18px;
          color: #ff0042;
        }
      }
      .close {
        font-size: 34px;
        color: #3c3c3c;
        cursor: pointer;
      }
    }
    .custom_popup_body {
      height: calc(100% - 270px);
      padding-bottom: 20px;
      box-sizing: border-box;
      margin: 0 0 30px;
      overflow-y: scroll;
      // 隐藏滚动条
      &::-webkit-scrollbar {
        display: none;
      }
      .custom_popup_body_list {
        align-items: flex-start;
        padding: 0 30px;
        flex-wrap: wrap;
        .custom_popup_body_item {
          // display: inline-block;
          border: 2px solid #ececec;
          font-size: 22px;
          color: #3c3c3c;
          border-radius: 30px;
          padding: 0 80px 0 35px;
          box-sizing: border-box;
          height: 60px;
          // line-height: 60px;
          position: relative;
          margin: 0 20px 10px 0;
          cursor: pointer;
          .active {
            display: inline-block;
            width: 31px;
            height: 30px;
            background: url("../../../assets/images/radio_select.png") no-repeat
              center;
            background-size: cover;
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
      .custom_date {
        height: 80%;
        .custom_date_img {
          width: 166px;
          height: 233px;
        }
        .custom_date_btn {
          width: 330px;
          height: 70px;
          background: #0031c9;
          border-radius: 35px;
          font-size: 26px;
          color: #fff;
          margin-top: 39px;
        }
      }

      .isLoading {
        // height: 40%;
        font-size: 28px;
      }
      .hasMore {
        font-size: 24px;
        padding: 40px 0 50px;
        box-sizing: border-box;
      }
    }
    .custom_popup_footer {
      box-shadow: 0 0 20px 20px rgba(0, 0, 0, 0.05);
      height: 160px;
      box-sizing: border-box;
      align-items: flex-start;
      font-size: 26px;
      cursor: pointer;
      .return {
        flex: 1;
        height: 100px;
      }
      .btn {
        width: 500px;
        height: 100px;
        background: #ff0039;
        color: #fff;
      }
    }
  }
}
</style>